var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSelfcheckin = function SvgSelfcheckin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.5C6.90703 6.5 8.25 5.04512 8.25 3.25C8.25 1.45488 6.90703 0 5.25 0C3.59297 0 2.25 1.45488 2.25 3.25C2.25 5.04512 3.59297 6.5 5.25 6.5ZM7.35 7.3125H6.95859C6.43828 7.57148 5.85937 7.71875 5.25 7.71875C4.64062 7.71875 4.06406 7.57148 3.5414 7.3125H3.15C1.41094 7.3125 0 8.84102 0 10.725V11.7812C0 12.4541 0.503906 13 1.125 13H9.37499C9.99609 13 10.5 12.4541 10.5 11.7812V10.725C10.5 8.84102 9.08906 7.3125 7.35 7.3125ZM14.9203 4.05234L14.2687 3.33887C14.1609 3.21953 13.9851 3.21953 13.875 3.33633L11.4187 5.97695L10.3523 4.81406C10.2445 4.69473 10.0687 4.69473 9.95859 4.81152L9.29999 5.51992C9.18984 5.63672 9.18984 5.82715 9.29765 5.94648L11.2125 8.03613C11.3203 8.15547 11.4961 8.15547 11.6062 8.03867L14.918 4.47891C15.0258 4.35957 15.0281 4.16914 14.9203 4.05234Z",
    fill: "#232323"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelfcheckin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/self check in.0df10516.svg";
export { ForwardRef as ReactComponent };